export default __webpack_public_path__ + "static/media/Steward_Particle_0001_Layer-75.bde8549b.png";